import { IReduxState } from 'types/redux';

export const commuteDetectorsSelector = (state: IReduxState) => state.processors.commuteDetectors;

export const attributeRangeDetectorsSelector = (state: IReduxState) => state.processors.attributeRange;

export const downsampledMessageHistorySelector = (state: IReduxState) => state.processors.downsampledMessageHistory;
